import { useState } from 'react'
import AdminLayout, { type AdminTab } from './AdminLayout'
import AdminOverview   from './AdminOverview'
import AccessControl   from './AccessControl'
import UserManagement  from './UserManagement'
import AuditLogPanel   from './AuditLogPanel'

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState<AdminTab>('overview')

  const renderTab = () => {
    switch (activeTab) {
      case 'overview': return <AdminOverview />
      case 'users':    return <UserManagement />
      case 'access':   return <AccessControl />
      case 'audit':    return <AuditLogPanel />
    }
  }

  return (
    <AdminLayout activeTab={activeTab} onTabChange={setActiveTab}>
      {renderTab()}
    </AdminLayout>
  )
}
